var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10C8.25 7.37665 10.3766 5.25 13 5.25H17C19.6234 5.25 21.75 7.37665 21.75 10C21.75 12.2143 20.2355 14.0731 18.1869 14.6003C17.7858 14.7036 17.3769 14.4621 17.2737 14.0609C17.1704 13.6598 17.4119 13.2509 17.8131 13.1477C19.215 12.7868 20.25 11.5133 20.25 10C20.25 8.20507 18.7949 6.75 17 6.75H13C11.2051 6.75 9.75 8.20507 9.75 10C9.75 11.202 10.4022 12.2526 11.3755 12.8157C11.7341 13.0231 11.8566 13.4819 11.6492 13.8404C11.4418 14.199 10.983 14.3215 10.6245 14.1141C9.20663 13.2939 8.25 11.7591 8.25 10ZM6.72633 9.93907C6.82957 10.3402 6.58808 10.7491 6.18694 10.8523C4.78504 11.2132 3.75 12.4867 3.75 14C3.75 15.7949 5.20507 17.25 7 17.25H11C12.7949 17.25 14.25 15.7949 14.25 14C14.25 12.798 13.5978 11.7474 12.6245 11.1843C12.2659 10.9769 12.1434 10.5181 12.3508 10.1596C12.5582 9.80104 13.017 9.67852 13.3755 9.88592C14.7934 10.7061 15.75 12.2409 15.75 14C15.75 16.6234 13.6234 18.75 11 18.75H7C4.37665 18.75 2.25 16.6234 2.25 14C2.25 11.7857 3.76451 9.92695 5.81306 9.39969C6.2142 9.29644 6.62308 9.53793 6.72633 9.93907Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAlt2);
export default __webpack_public_path__ + "static/media/link-alt-2.41b790fdc1757459dd14e9d6fb0a55cd.svg";
export { ForwardRef as ReactComponent };